export default __webpack_public_path__ + "static/media/manutencao.c025a3ad.svg";